import $ from 'jquery';
export default class FocusOnClick {
    static init() {
        const $button = $('.js__focus-on-click');
        if (!$button.length) {
            return;
        }
        $button.each((index, element) => {
            const $element = $(element);
            $element.on('click', () => {
                this.setElementFocus($($element.data('focus-element')));
            });
            $element.on('keydown', event => {
                if (event.key === 'Enter' || event.key === ' ') {
                    this.setElementFocus($($element.data('focus-element')));
                }
            });
        });
    }
    static setElementFocus($element) {
        const $focusableElement = $element.find('a, button, textarea, input, select, .js__custom-dropdown-button').first();
        $focusableElement.trigger('focus');
    }
}
